'use client';
var classes = {"root":"m-17884d0f","viewport":"m-a2dae653","container":"m-fcd81474","controls":"m-39bc3463","control":"m-64f58e10","indicators":"m-71ea3ab1","indicator":"m-eae68602","slide":"m-d98df724"};

export { classes as default };
//# sourceMappingURL=Carousel.module.css.mjs.map
